import React from 'react';

interface Unipole3DIconProps {
  size?: number;
  color?: string;
}

export const Unipole3DIcon = ({ size = 48, color = '#0b7b41' }: Unipole3DIconProps) => {
  const darkerColor = adjustBrightness(color, -30);
  const lighterColor = adjustBrightness(color, 40);

  return (
    <svg width={size} height={size} viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
      {/* Shadow */}
      <ellipse cx="32" cy="58" rx="10" ry="3" fill="rgba(0,0,0,0.2)" />
      {/* Base plate */}
      <ellipse cx="32" cy="56" rx="8" ry="2.5" fill={darkerColor} />
      <ellipse cx="32" cy="55" rx="8" ry="2.5" fill={color} />
      {/* Single pole */}
      <rect x="30" y="28" width="3" height="27" fill={darkerColor} />
      <rect x="29" y="28" width="3" height="27" fill={color} />
      {/* Sign panel - front face */}
      <rect x="10" y="6" width="40" height="22" rx="2" fill={color} />
      {/* Sign panel - right side (3D effect) */}
      <path d="M50 6 L54 3 L54 25 L50 28 Z" fill={darkerColor} />
      {/* Sign panel - top (3D effect) */}
      <path d="M10 6 L14 3 L54 3 L50 6 Z" fill={lighterColor} />
      {/* Inner display area */}
      <rect x="13" y="9" width="34" height="16" rx="1" fill="white" opacity="0.25" />
      {/* Content line */}
      <rect x="16" y="14" width="20" height="2" rx="1" fill="white" opacity="0.4" />
      <rect x="16" y="19" width="14" height="2" rx="1" fill="white" opacity="0.3" />
      {/* Shine */}
      <rect x="10" y="6" width="40" height="3" rx="2" fill="white" opacity="0.15" />
    </svg>
  );
};

function adjustBrightness(hex: string, amount: number): string {
  const num = parseInt(hex.replace('#', ''), 16);
  const r = Math.min(255, Math.max(0, (num >> 16) + amount));
  const g = Math.min(255, Math.max(0, ((num >> 8) & 0x00FF) + amount));
  const b = Math.min(255, Math.max(0, (num & 0x0000FF) + amount));
  return `#${(r << 16 | g << 8 | b).toString(16).padStart(6, '0')}`;
}
